import { render, staticRenderFns } from "./DesktopJoinDetailPage.vue?vue&type=template&id=4827b9b2&scoped=true"
import script from "./DesktopJoinDetailPage.vue?vue&type=script&lang=js"
export * from "./DesktopJoinDetailPage.vue?vue&type=script&lang=js"
import style0 from "./DesktopJoinDetailPage.vue?vue&type=style&index=0&id=4827b9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4827b9b2",
  null
  
)

export default component.exports